



















































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import searchInput from "@/components/searchInput.vue";
import util from "@/lib/util";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import DescriptionList from "@/components/DescriptionList/DescriptionList.vue";
import DescriptionListItem from "@/components/DescriptionList/DescriptionListItem.vue";
import AppConsts from "@/lib/appconst";

@Component({
    components: {
        DescriptionListItem,
        DescriptionList,
        ShortHeaderLayout,
        basicPage,
        allTrain,
        myTrain,
        searchInput
    },
    filters: {
        imgUrlFilter(url: string) {
            if (url && url.indexOf('http') > -1) {
                return url;
            } else if(url){
                let fileResourceUrl: string = AppConsts.fileResourceUrl;
                return `${fileResourceUrl}${url}`;
            }else {
                return '/img/icons/avatar_def_icon.png';
            }
        }
    }
})
export default class userOverview extends basicPage {
    customActiveKey = '0'
    hasHeight: boolean = false;
    data: any = {};

    handleTabClick(e) {
        this.customActiveKey = e;
    }

    loadData() {
        ajaxHelperInstance.get('web/auth/info').then((res) => {
            let {data, errno, message} = res.data;
            if (errno != 0) {
                return
            }
            this.data = data;
            console.log(data);
        })
    }


    changeUserInfo() {
        this.$router.push({
            name: 'userinfo',
        })
    }

    getGender(type) {
        type = parseInt(type);
        let rpc = {
            1: '男',
            2: '女'
        }
        return rpc[type];
    }

    viewData(type) {
        let arr = {
            0: 'myquestion',
            1: 'myanswer',
            2: 'myapply',
            3: 'mycollect'
        }

        let target = arr[type];
        if (target) {
            this.$router.push({
                name: target
            })
        }
    }


    getAvatorUrl(url) {
        if (url) {
            url = AppConsts.fileResourceUrl + url;
        }
        return url;
    }


    mounted() {
        this.loadData();
    }

}
